import type { MaterialFontIconDefinition } from "./IconType";

const OUTLINE: MaterialFontIconDefinition["fill"] = 0;
const FILLED: MaterialFontIconDefinition["fill"] = 1;

const materialSymbol = (
  ligature: string,
  fill: MaterialFontIconDefinition["fill"],
): MaterialFontIconDefinition => ({
  kind: "font",
  ligature,
  fill,
});

export const MaterialSymbolsType = {
  ACCOUNT_MULTIPLE: materialSymbol("group", FILLED),
  ACCOUNT_CIRCLE: materialSymbol("account_circle", FILLED),
  ACCOUNT_MULTIPLE_OUTLINE: materialSymbol("group", OUTLINE),
  ACCOUNT_PLUS: materialSymbol("person_add", FILLED),
  ACCOUNT_STAR_OUTLINE: materialSymbol("person_heart", OUTLINE),
  ACCOUNT_SUPERVISOR: materialSymbol("supervisor_account", FILLED),
  ACCOUNT_SUPERVISOR_OUTLINE: materialSymbol("supervisor_account", OUTLINE),
  ACCOUNT_TAG_OUTLINE: materialSymbol("person_text", OUTLINE),
  ALERT: materialSymbol("warning", FILLED),
  ALERT_CIRCLE_OUTLINE: materialSymbol("error", OUTLINE),
  ALERT_FILLED: materialSymbol("error", FILLED),
  APPLE_COMMAND: materialSymbol("keyboard_command_key", FILLED),
  ARROW_DOWN: materialSymbol("arrow_downward", FILLED),
  ARROW_RIGHT: materialSymbol("arrow_forward", FILLED),
  ARROW_TOP_RIGHT: materialSymbol("arrow_outward", FILLED),
  ARROW_U_LEFT_TOP: materialSymbol("undo", FILLED),
  ARROW_UP: materialSymbol("arrow_upward", FILLED),
  AUTORENEW: materialSymbol("autorenew", FILLED),
  BANK_TRANSFER: materialSymbol("assured_workload", FILLED),
  BANK: materialSymbol("account_balance", FILLED),
  BARLEY_OFF: materialSymbol("wheat", FILLED),
  BELL: materialSymbol("notifications", FILLED),
  BELL_ALERT: materialSymbol("notifications_unread", FILLED),
  BELL_OFF_OUTLINE: materialSymbol("notifications_off", OUTLINE),
  BELL_OUTLINE: materialSymbol("notifications", OUTLINE),
  BELL_RING: materialSymbol("notifications_active", FILLED),
  BOOK_OUTLINE: materialSymbol("book", OUTLINE),
  BULLHORN: materialSymbol("campaign", FILLED),
  BULLHORN_OUTLINE: materialSymbol("campaign", OUTLINE),
  CALENDAR_BLANK_OUTLINE: materialSymbol("calendar_today", OUTLINE),
  CALENDAR_CHECK_OUTLINE: materialSymbol("event_available", OUTLINE),
  CALENDAR_CLOCK: materialSymbol("calendar_clock", FILLED),
  CALENDAR_CLOCK_OUTLINE: materialSymbol("calendar_clock", OUTLINE),
  CALENDAR_OUTLINE: materialSymbol("event", OUTLINE),
  CARD_ID_OUTLINE: materialSymbol("id_card", OUTLINE),
  CART: materialSymbol("shopping_cart", FILLED),
  CART_OUTLINE: materialSymbol("shopping_cart", OUTLINE),
  CAUTION: materialSymbol("warning", FILLED),
  CELLPHONE: materialSymbol("mobile", OUTLINE),
  CHART_BOX: materialSymbol("insert_chart", FILLED),
  CHART_BOX_OUTLINE: materialSymbol("insert_chart", OUTLINE),
  CHECK: materialSymbol("check", FILLED),
  CHECK_ALL: materialSymbol("done_all", FILLED),
  CHECK_CIRCLE: materialSymbol("check_circle", FILLED),
  CHECKBOX_BLANK_CIRCLE: materialSymbol("radio_button_unchecked", FILLED),
  CHECKBOX_BLANK_CIRCLE_OUTLINE: materialSymbol(
    "radio_button_unchecked",
    OUTLINE,
  ),
  CHECKBOX_BLANK_OUTLINE: materialSymbol("check_box_outline_blank", OUTLINE),
  CHECKBOX_MARKED: materialSymbol("check_box", FILLED),
  CHECKBOX_MARKED_CIRCLE: materialSymbol("check_circle", FILLED),
  CHEVRON_DOUBLE_LEFT: materialSymbol("keyboard_double_arrow_left", FILLED),
  CHEVRON_DOUBLE_RIGHT: materialSymbol("keyboard_double_arrow_right", FILLED),
  CHEVRON_DOWN: materialSymbol("keyboard_arrow_down", FILLED),
  CHEVRON_LEFT: materialSymbol("chevron_left", FILLED),
  CHEVRON_RIGHT: materialSymbol("chevron_right", FILLED),
  CHEVRON_UP: materialSymbol("keyboard_arrow_up", FILLED),
  CIRCLE: materialSymbol("circle", FILLED),
  CLIPBOARD_CHECK_OUTLINE: materialSymbol("assignment_turned_in", OUTLINE),
  CLOCK_FAST_OUTLINE: materialSymbol("acute", OUTLINE),
  CLOCK_OUTLINE: materialSymbol("schedule", OUTLINE),
  CLOSE: materialSymbol("close", FILLED),
  COG: materialSymbol("settings", FILLED),
  COG_OUTLINE: materialSymbol("settings", OUTLINE),
  COMMENT_TEXT_OUTLINE: materialSymbol("comment", OUTLINE),
  COMPARE_HORIZONTAL: materialSymbol("compare_arrows", FILLED),
  CONTENT_COPY: materialSymbol("content_copy", FILLED),
  CONTENT_COPY_OUTLINE: materialSymbol("content_copy", OUTLINE),
  CREDIT_CARD: materialSymbol("credit_card", FILLED),
  CREDIT_CARD_EDIT_OUTLINE: materialSymbol("credit_card_gear", OUTLINE),
  CREDIT_CARD_FAST_OUTLINE: materialSymbol("credit_card", OUTLINE),
  CREDIT_CARD_MARKER_OUTLINE: materialSymbol("payment_arrow_down", OUTLINE),
  CREDIT_CARD_REMOVE: materialSymbol("credit_card_off", FILLED),
  CURRENCY_GBP: materialSymbol("currency_pound", FILLED),
  CURRENCY_GBP_OUTLINE: materialSymbol("currency_pound", OUTLINE),
  DELETE: materialSymbol("delete", FILLED),
  DELIVERY_BOX: materialSymbol("package_2", OUTLINE),
  DESKTOP: materialSymbol("desktop_windows", OUTLINE),
  DOTS_HORIZONTAL_CIRCLE: materialSymbol("pending", FILLED),
  DOTS_VERTICAL: materialSymbol("more_vert", FILLED),
  DOWNLOAD: materialSymbol("download_2", FILLED),
  DOWNLOAD_ARROW: materialSymbol("download_2", FILLED),
  EMAIL: materialSymbol("mail", FILLED),
  EMAIL_LOCK_OUTLINE: materialSymbol("mail_lock", OUTLINE),
  EMAIL_PLUS: materialSymbol("mail", FILLED),
  EXIT_TO_APP: materialSymbol("exit_to_app", FILLED),
  EXPORT: materialSymbol("output", FILLED),
  EXPORT_VARIANT: materialSymbol("ios_share", OUTLINE),
  EYE: materialSymbol("visibility", FILLED),
  EYE_OFF: materialSymbol("visibility_off", FILLED),
  EYE_OUTLINE: materialSymbol("visibility", OUTLINE),
  FACTORY: materialSymbol("factory", FILLED),
  FACTORY_OUTLINE: materialSymbol("factory", OUTLINE),
  FERRY: materialSymbol("directions_boat", FILLED),
  FILE_DOCUMENT_ALERT_OUTLINE: materialSymbol("assignment_late", OUTLINE),
  FILE_DOCUMENT_ARROW_RIGHT_OUTLINE: materialSymbol("assignment", OUTLINE),
  FILE_DOCUMENT_CHECK_OUTLINE: materialSymbol("assignment_turned_in", OUTLINE),
  FILE_DOCUMENT_OUTLINE: materialSymbol("description", OUTLINE),
  CONTACT_PAGE_OUTLINE: materialSymbol("description", OUTLINE),
  FILE_DOCUMENT_REMOVE_OUTLINE: materialSymbol("scan_delete", OUTLINE),
  FILE_MARKER_OUTLINE: materialSymbol("assignment_returned", OUTLINE),
  FILE_OUTLINE: materialSymbol("description", OUTLINE),
  FILTER: materialSymbol("filter_alt", FILLED),
  FILTER_VARIANT: materialSymbol("filter_list", FILLED),
  FORMAT_LIST_BULLETED: materialSymbol("format_list_bulleted", FILLED),
  FORMAT_LIST_BULLETED_SQUARE: materialSymbol("lists", FILLED),
  GLASS_MUG_VARIANT: materialSymbol("sports_bar", FILLED),
  GRID: materialSymbol("grid_on", OUTLINE),
  GRID_OUTLINE: materialSymbol("grid_view", OUTLINE),
  HAND_EXTENDED: materialSymbol("approval_delegation", FILLED),
  HAND_EXTENDED_OUTLINE: materialSymbol("approval_delegation", OUTLINE),
  HANDSHAKE: materialSymbol("handshake", FILLED),
  HEART: materialSymbol("favorite", FILLED),
  HEART_OUTLINE: materialSymbol("favorite", OUTLINE),
  HELP_CIRCLE: materialSymbol("help", FILLED),
  HELP_CIRCLE_OUTLINE: materialSymbol("help", OUTLINE),
  HISTORY: materialSymbol("history", FILLED),
  HOME: materialSymbol("home", FILLED),
  IMAGE_OUTLINE: materialSymbol("image", OUTLINE),
  IMAGE_TEXT: materialSymbol("image", FILLED),
  INBOX_ARROW_DOWN: materialSymbol("move_to_inbox", FILLED),
  INBOX_ARROW_DOWN_OUTLINE: materialSymbol("move_to_inbox", OUTLINE),
  INFORMATION: materialSymbol("info", FILLED),
  INFORMATION_OUTLINE: materialSymbol("info", OUTLINE),
  KEYBOARD_RETURN: materialSymbol("keyboard_return", FILLED),
  LABEL_OFF_OUTLINE: materialSymbol("label_off", OUTLINE),
  LEAF: materialSymbol("eco", FILLED),
  LICENSE: materialSymbol("workspace_premium", FILLED),
  LIGHTNING_BOLT: materialSymbol("bolt", FILLED),
  MERGE: materialSymbol("merge", FILLED),
  LINK: materialSymbol("link", FILLED),
  LINK_OFF: materialSymbol("link_off", FILLED),
  LOCK: materialSymbol("lock", FILLED),
  LOCK_OUTLINE: materialSymbol("lock", OUTLINE),
  LOCK_OUTLINE_OPEN: materialSymbol("lock_open", FILLED),
  LOGIN: materialSymbol("subdirectory_arrow_right", OUTLINE),
  LOGIN_VARIANT: materialSymbol("login", OUTLINE),
  MAGNIFY: materialSymbol("search", FILLED),
  MAGNIFY_OUTLINE: materialSymbol("search", OUTLINE),
  MAP: materialSymbol("map", FILLED),
  MAP_CLOCK: materialSymbol("map", FILLED),
  MAP_MARKER: materialSymbol("location_on", FILLED),
  MAP_MARKER_OUTLINE: materialSymbol("location_on", OUTLINE),
  MENU: materialSymbol("menu", FILLED),
  MENU_OPEN: materialSymbol("menu_open", FILLED),
  MESSAGE_OUTLINE: materialSymbol("chat", OUTLINE),
  MESSAGE_REPLY_TEXT: materialSymbol("forum", FILLED),
  MINUS: materialSymbol("remove", FILLED),
  NOTE_ALT_OUTLINE: materialSymbol("note_alt", OUTLINE),
  NOTE_EDIT_OUTLINE: materialSymbol("edit_document", OUTLINE),
  NOTE_OFF_OUTLINE: materialSymbol("file_copy_off", OUTLINE),
  NOTE_REMOVE_OUTLINE: materialSymbol("file_copy_off", OUTLINE),
  NOTE_TEXT_OUTLINE: materialSymbol("description", OUTLINE),
  OPEN_IN_NEW: materialSymbol("open_in_new", FILLED),
  PACKAGE_VARIANT_CLOSED: materialSymbol("package_2", OUTLINE),
  PACKAGE_VARIANT_CLOSED_FILL: materialSymbol("package_2", FILLED),
  PACKAGE_VARIANT_CLOSED_PLUS: materialSymbol("hand_package", OUTLINE),
  PARTY_POPPER: materialSymbol("celebration", FILLED),
  PENCIL: materialSymbol("edit", FILLED),
  PENCIL_OUTLINE: materialSymbol("edit", OUTLINE),
  PERCENT: materialSymbol("percent", FILLED),
  PHONE: materialSymbol("call", FILLED),
  PHOTO_CAMERA: materialSymbol("photo_camera", OUTLINE),
  PLUS: materialSymbol("add", FILLED),
  PLUS_BOX_MULTIPLE_OUTLINE: materialSymbol("library_add", OUTLINE),
  PLUS_BOX_OUTLINE: materialSymbol("add_box", OUTLINE),
  PLUS_CIRCLE: materialSymbol("add_circle", FILLED),
  POUND: materialSymbol("tag", FILLED),
  PRINTER: materialSymbol("print", FILLED),
  PROFILE: materialSymbol("account_circle", FILLED),
  PROGRESS_CLOCK: materialSymbol("search_activity", FILLED),
  PROGRESS_HELPER: materialSymbol("progress_activity", FILLED),
  QRCODE: materialSymbol("qr_code_2", FILLED),
  RECEIPT_TEXT_OUTLINE: materialSymbol("receipt", OUTLINE),
  REFRESH: materialSymbol("refresh", FILLED),
  REMOVE: materialSymbol("remove", FILLED),
  REPEAT: materialSymbol("repeat", FILLED),
  ROTATE_360: materialSymbol("360", FILLED),
  ROTATE_LEFT: materialSymbol("rotate_left", FILLED),
  SAFE_SQUARE_OUTLINE: materialSymbol("house_with_shield", OUTLINE),
  SALE: materialSymbol("percent_discount", FILLED),
  SEND: materialSymbol("send", FILLED),
  SHARE: materialSymbol("share", FILLED),
  SHARE_OUTLINE: materialSymbol("share", OUTLINE),
  SHIELD_CROWN_OUTLINE: materialSymbol("shield", OUTLINE),
  SHOPPING_BASKET: materialSymbol("shopping_basket", OUTLINE),
  SORT: materialSymbol("sort", FILLED),
  SORT_VARIANT: materialSymbol("sort", FILLED),
  STAR_SHINE: materialSymbol("star_shine", FILLED),
  STAR: materialSymbol("star", FILLED),
  STAR_OUTLINE: materialSymbol("star", OUTLINE),
  STOREFRONT: materialSymbol("storefront", FILLED),
  STOREFRONT_OUTLINE: materialSymbol("storefront", OUTLINE),
  SWAP_HORIZONTAL: materialSymbol("swap_horiz", FILLED),
  SWAP_VERTICAL: materialSymbol("swap_vert", FILLED),
  SYNC: materialSymbol("sync", FILLED),
  TAG: materialSymbol("sell", FILLED),
  TAG_MULTIPLE_OUTLINE: materialSymbol("sell", OUTLINE),
  TAG_OFF_OUTLINE: materialSymbol("label_off", OUTLINE),
  TAG_OUTLINE: materialSymbol("sell", OUTLINE),
  TEXT_BOX_SEARCH_OUTLINE: materialSymbol("manage_search", OUTLINE),
  THUMB_UP: materialSymbol("thumb_up", FILLED),
  THUMB_UP_OUTLINE: materialSymbol("thumb_up", OUTLINE),
  TICKET: materialSymbol("local_activity", FILLED),
  TIMER_SAND_EMPTY: materialSymbol("hourglass_empty", FILLED),
  TRAY_ARROW_DOWN: materialSymbol("download", OUTLINE),
  TRUCK: materialSymbol("local_shipping", FILLED),
  TRUCK_DELIVERY: materialSymbol("delivery_truck_speed", OUTLINE),
  TRUCK_OUTLINE: materialSymbol("local_shipping", OUTLINE),
  UNDO: materialSymbol("undo", FILLED),
  UNFOLD: materialSymbol("unfold_more", FILLED),
  UPLOAD: materialSymbol("upload", FILLED),
  VIEW_DASHBOARD_OUTLINE: materialSymbol("dashboard", OUTLINE),
  WATER_OFF: materialSymbol("water_drop", FILLED),
  WEB: materialSymbol("public", FILLED),
} as const;
